export const GLOBAL_STATE = 'Departments'

export const DEPARTMENT = 'department'
export const DEPARTMENT_CREATE = 'departmentCreate'
export const DEPARTMENT_LIST = 'departmentList'
export const DEPARTMENT_ALL = 'departmentAll'
export const DEPARTMENT_LABELS = 'departmentLabels'
